//==========import components===============
import HomeLayout from 'layouts/HomeLayout';
import TakeCare from 'components/common/TakeCare';
import CeoMessage from 'components/about-us/CeoMessage';
import AboutHistory from 'components/about-us/AboutHistory';
import AboutVision from 'components/about-us/AboutVision';

const AboutUs = () => {
  return (
    <div className='AboutUsPage DBlock relative'>
      <AboutHistory />
      <TakeCare />
      <AboutVision />
      <CeoMessage />
    </div>
  );
};

export default HomeLayout(AboutUs);
